import { render, staticRenderFns } from "./GestionTemplates.vue?vue&type=template&id=1c42cce9"
import script from "./GestionTemplates.vue?vue&type=script&lang=js"
export * from "./GestionTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports